(() => {
  const colorParam = 'filter.v.t.shopify.color-pattern';
  const extraParam = 'vhalam_color';
  if (!location.pathname.startsWith('/collections/')) return;

  function selectedColors() {
    const params = new URL(location.href).searchParams;
    return [...new Set([...params.getAll(colorParam), ...params.getAll(extraParam)].filter(Boolean))];
  }

  function navigateWithColors(colors, form, changedName = '') {
    const url = new URL(location.href);
    const hadPrice = [...url.searchParams.keys()].some((name) => name.startsWith('filter.v.price.'));
    url.searchParams.delete('page');
    url.searchParams.delete(colorParam);
    url.searchParams.delete(extraParam);
    if (form) {
      const data = new FormData(form);
      for (const name of [...url.searchParams.keys()]) {
        if (name.startsWith('filter.')) url.searchParams.delete(name);
      }
      const names = new Set([...data.keys()].filter((name) => name !== colorParam && name !== extraParam &&
        (!name.startsWith('filter.v.price.') || hadPrice || changedName.startsWith('filter.v.price.'))));
      for (const name of names) {
        url.searchParams.delete(name);
        for (const value of data.getAll(name)) {
          if (String(value).trim()) url.searchParams.append(name, value);
        }
      }
    }
    if (colors[0]) url.searchParams.set(colorParam, colors[0]);
    for (const color of colors.slice(1)) url.searchParams.append(extraParam, color);
    location.assign(url.href);
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    const form = input.closest?.('.collection-filters-form');
    if (!form) return;
    if (input.name === colorParam) {
      event.stopImmediatePropagation();
      const colors = selectedColors().filter((color) => color !== input.value);
      if (input.checked) colors.push(input.value);
      navigateWithColors(colors, form, input.name);
    } else if (selectedColors().length > 1) {
      event.stopImmediatePropagation();
      navigateWithColors(selectedColors(), form, input.name);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('.collection-filters-form') || selectedColors().length < 2) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigateWithColors(selectedColors(), form);
  }, true);

  function revealInputs() {
    document.querySelectorAll(`.collection-filters-form input[name="${colorParam}"]`).forEach((input) => {
      input.disabled = false;
    });
  }

  function syncInputs() {
    const colors = selectedColors();
    revealInputs();
    document.querySelectorAll(`.collection-filters-form input[name="${colorParam}"]`).forEach((input) => {
      input.checked = colors.includes(input.value);
    });
    document.querySelectorAll('[data-collection-filter-label][data-filter-label="Color"]').forEach((label) => {
      const count = [...label.querySelectorAll('span')].find((item) => /^\(\d+\)$/.test(item.textContent.trim()));
      if (count) {
        count.textContent = `(${colors.length})`;
        if (count.hasAttribute('aria-label')) count.setAttribute('aria-label', `${colors.length} selected`);
      }
    });
  }

  const filterObserver = new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList')) revealInputs();
  });
  filterObserver.observe(document.body, { subtree: true, childList: true });

  async function fetchPage(url, sectionId) {
    const request = new URL(url, location.origin);
    request.searchParams.set('section_id', sectionId);
    const response = await fetch(request, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error(`Color results unavailable (${response.status})`);
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const results = page.querySelector('.collection-products vhalam-infinite-collection');
    const cards = results?.querySelectorAll('.product-list > [data-product-id]');
    if (!results || !cards) throw new Error('Missing color results');
    return { cards: [...cards], next: results.dataset.nextUrl || '' };
  }

  async function fetchPages(url, sectionId, onPage) {
    let next = url;
    const visited = new Set();
    while (next) {
      const current = new URL(next, location.origin);
      current.searchParams.set('section_id', sectionId);
      if (visited.has(current.href)) throw new Error('Repeated collection page');
      visited.add(current.href);
      const page = await fetchPage(current, sectionId);
      if (onPage(page.cards) === false) break;
      next = page.next;
    }
  }

  function updateSelectedChips(colors) {
    const nav = document.querySelector('.collection-utilities .collection-active-filters');
    const list = nav?.querySelector('.collection-active-filters__list');
    if (!list) return;
    const primaryChip = [...list.querySelectorAll('.collection-active-filter')].find((chip) =>
      new URL(chip.href).searchParams.get(colorParam) !== colors[0]);
    if (primaryChip) {
      const promoted = new URL(location.href);
      promoted.searchParams.set(colorParam, colors[1]);
      promoted.searchParams.delete(extraParam);
      for (const remaining of colors.slice(2)) promoted.searchParams.append(extraParam, remaining);
      primaryChip.href = promoted.href;
    }
    const inputs = [...document.querySelectorAll(`input[name="${colorParam}"]`)];
    for (const color of colors.slice(1)) {
      const input = inputs.find((item) => item.value === color);
      const label = input?.labels?.[0]?.textContent?.replace(/\(\d+\)/, '').trim() || 'Color';
      const url = new URL(location.href);
      url.searchParams.delete(extraParam);
      for (const remaining of colors.slice(1).filter((item) => item !== color)) url.searchParams.append(extraParam, remaining);
      const chip = document.createElement('a');
      chip.className = 'collection-active-filter';
      chip.href = url.href;
      chip.textContent = `Color: ${label} ×`;
      list.insertBefore(chip, list.querySelector('.collection-active-filters__clear'));
    }
  }

  async function showUnion() {
    const colors = selectedColors();
    syncInputs();
    if (colors.length < 2) return;

    const results = document.querySelector('.collection-products vhalam-infinite-collection');
    const grid = results?.querySelector('.product-list');
    const sectionId = results?.dataset.sectionId;
    const status = results?.querySelector('[data-infinite-scroll-status]');
    const message = results?.querySelector('[data-infinite-scroll-message]');
    if (!results || !grid || !sectionId || !status) return;

    results.dataset.colorUnionLoading = '';
    status.hidden = false;
    status.setAttribute('aria-busy', 'true');
    if (message) message.textContent = results.dataset.loadingLabel || 'Loading products';
    updateSelectedChips(colors);

    try {
      const cardsById = new Map();
      const base = new URL(location.href);
      base.searchParams.delete('page');
      base.searchParams.delete(extraParam);
      if (base.searchParams.get('sort_by') === 'discounted') base.searchParams.delete('sort_by');

      for (const color of colors) {
        const colorUrl = new URL(base);
        colorUrl.searchParams.set(colorParam, color);
        await fetchPages(colorUrl, sectionId, (cards) => {
          for (const card of cards) {
            if (card.dataset.productId) cardsById.set(card.dataset.productId, card);
          }
        });
      }

      const ordered = [];
      const unfiltered = new URL(base);
      unfiltered.searchParams.delete(colorParam);
      await fetchPages(unfiltered, sectionId, (cards) => {
        for (const card of cards) {
          const selected = cardsById.get(card.dataset.productId);
          if (selected) {
            ordered.push(selected);
            cardsById.delete(card.dataset.productId);
          }
        }
        return cardsById.size > 0;
      });
      if (cardsById.size) throw new Error('Incomplete color result ordering');
      if (new URL(location.href).searchParams.get('sort_by') === 'discounted') {
        ordered.sort((a, b) => Number(b.dataset.discounted === 'true') - Number(a.dataset.discounted === 'true'));
      }

      grid.replaceChildren();
      if (ordered.length) document.querySelector('.collection-products [data-collection-empty]')?.remove();
      results.classList.add('collection-products__results--infinite');
      document.querySelectorAll('.collection-product-count').forEach((count) => {
        count.textContent = `${ordered.length} ${ordered.length === 1 ? 'product' : 'products'}`;
      });
      document.querySelectorAll('.collection-filters-form .collection-sidebar__apply, .collection-filter-sheet__view').forEach((button) => {
        button.textContent = `View ${ordered.length} ${ordered.length === 1 ? 'result' : 'results'}`;
      });
      let index = 0;
      const append = () => {
        const fragment = document.createDocumentFragment();
        for (const card of ordered.slice(index, index + 16)) fragment.append(document.importNode(card, true));
        grid.append(fragment);
        index = Math.min(index + 16, ordered.length);
        status.hidden = index >= ordered.length;
        if (message) message.textContent = index >= ordered.length ? results.dataset.completeLabel : results.dataset.loadedLabel;
      };
      append();
      if (index < ordered.length) {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            append();
            if (index >= ordered.length) observer.disconnect();
          }, { rootMargin: '600px 0px' });
          observer.observe(status);
        } else {
          while (index < ordered.length) append();
        }
      }
    } catch (error) {
      console.error('Unable to combine selected colors', error);
      results.classList.remove('collection-products__results--infinite');
      if (message) message.textContent = 'Unable to combine colors. Showing the first selected color.';
    } finally {
      delete results.dataset.colorUnionLoading;
      status.setAttribute('aria-busy', 'false');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showUnion, { once: true });
  else showUnion();
})();
